import React from "react";
import classes from "./ImageContentCardMobile.module.scss";
import LatestNewsCardMobile from "./ImageContentCardMobile/LatestNewsCardMobile";

type Props = {
  data?: any;
  numItemsToShow?: number;
  title?: string;
};
const ImageContentCardMobile = ({
  data,
  title,
  numItemsToShow,
}: Props) => {
  return (
    <div className={classes["latest-news-mobile-container"]}>
      <div className={classes["title"]}>{title}</div>
      <div className={classes["newsCards"]}>
        {data?.length > 0 ? (
          data.slice(0, numItemsToShow).map((el: any, index: any) => (
            <React.Fragment key={index}>
              <LatestNewsCardMobile news={el} />
              <div className={classes["separator"]} />
            </React.Fragment>
          ))
        ) : (
          <div className={classes['no-data']}>No news available.</div>
        )}
      </div>
    </div>
  );
};

export default ImageContentCardMobile;
